import { render } from "./QuestionsManager.vue?vue&type=template&id=498fbfe9&scoped=true"
import script from "./QuestionsManager.vue?vue&type=script&lang=js"
export * from "./QuestionsManager.vue?vue&type=script&lang=js"

import "./QuestionsManager.vue?vue&type=style&index=0&id=498fbfe9&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498fbfe9"]])

export default __exports__